import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as ArrowBig } from 'icons/components/arrowBig.svg';

import './index.less';
import './themes/default.less';

export default class ControlDate extends MainComponent {
    static propTypes = {
        period: PropTypes.string,
        days: PropTypes.number,
        value: PropTypes.instanceOf(Date),
        onChange: PropTypes.func
    };

    static defaultProps = {
        period: "day",
        days: 1,
        value: "",
        onChange: null
    };

    changeDay(flag) {
        const { value, period } = this.props;

        let newDate = value;

        if (period === "day")
            newDate = this._helper.date.addDays(value, flag);
        else if (period === "week")
            newDate = this._helper.date.addDays(value, flag * 7);
        else
            newDate = this._helper.date.addMonth(value, flag);

        if (this.props.onChange)
            this.props.onChange(newDate);
    }

    insertArrow(isLeft = true) {
        const flag = isLeft ? -1 : 1;
        const cl = isLeft ? "rotate180" : "";

        return (
            <div className="blockArrow flex centerAll rad4 hand" onClick={this.changeDay.bind(this, flag)}>
                <ArrowBig className={cl} />
            </div>
        );
    }

    formatText() {
        const { value, period } = this.props;

        if (period === "day")
            return this._helper.date.toTodayStr(value, "D MMMM YYYY");
        else if (period === "week")
            return this._helper.date.getWeekString(value);

        return this._helper.string.capitalize(this._helper.date.getMonthName(value));
    }

    render() {
        return (
            <div className="controlDate">
                <div className="blockSelectDate flex">
                    {this.insertArrow()}
                    {this.insertArrow(false)}
                    <div className="flex centerV text blockTitle">
                        {this.formatText()}
                    </div>
                </div>
            </div>
        );
    }
}
